import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-dropdown-status',
  templateUrl: './dropdown-status.component.html',
  styleUrl: './dropdown-status.component.scss'
})
export class DropdownStatusComponent {
  public STATUS = [
    { value: 0, label: 'Delisted' },
    { value: 1, label: 'Active' },
    { value: 2, label: 'Hidden' },
    { value: 3, label: 'Sold' },
    { value: 4, label: 'Out of Stock' },
  ];
  isDropdownStatusOpen = false;
  @Input() value: any;
  @Input() size: any;
  @Output() change = new EventEmitter<any>();
  select(value:string) {
    this.change.emit(JSON.stringify(value));
  }
}
